import * as React from 'react'

import { IProject } from '~/client/graph'
import ProjectSelector, {
  ProjectSelectorTriggerSurface,
} from '~/client/src/shared/components/ProjectSelector/ProjectSelector'
import Project from '~/client/src/shared/models/Project'

interface IProps {
  projects: IProject[]
  activeProject: Project
  onSelectProject: (project: IProject) => void
}

export default function SidebarHeader({
  projects,
  activeProject,
  onSelectProject,
}: IProps) {
  return (
    <div className="tw:shrink-0 tw:px-4 tw:pt-4">
      <ProjectSelector
        isLoading={false}
        isDisabled={false}
        currentProject={activeProject}
        projects={projects}
        onItemSelect={onSelectProject}
        isMobileMode
      >
        <ProjectSelectorTriggerSurface
          data-testid="sidebar-project-selector"
          size="lg"
          className="tw:bg-background tw:text-foreground"
        />
      </ProjectSelector>
    </div>
  )
}
